import { useContext } from "react";
import { useSelector } from "react-redux";
import { Preferences } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  preferences: Preferences;
  retrievePreferences(): void;
}

function useRetrievePreferences(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isRetrievePreferencesRequestPending),
    isRequestSuccess: useSelector(selector.isRetrievePreferencesRequestSuccess),
    isRequestFailure: useSelector(selector.isRetrievePreferencesRequestFailure),
    preferences: useSelector(selector.getPreferences),
    retrievePreferences: core.retrievePreferences,
  };
}

export { useRetrievePreferences };
